/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit, OnChanges, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';

import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { Constants, Language } from '../constants';

@Component({
  selector: 'language-picker',
  templateUrl: './language-picker.component.html',
  styleUrls: ['./language-picker.component.scss']
})
export class LanguagePickerComponent implements OnInit {

  @Input()
  selectedLanguages: any[] = [];
  @Input()
  options: LanguagePickerOptions;

  @Output('onChange')
  onChange: EventEmitter<any> = new EventEmitter<any>();

  selectedLanguagesInternal: any[] = [];
  languages: any[] = [];
  languageDDSettings: any = {
    enableCheckAll: false,
    text: 'Select language(s)',
    unSelectAllText: 'Remove all but English',
    badgeShowLimit: 0
  };

  constructor(private constants: Constants,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.languageDDSettings.badgeShowLimit = this.options.badgeShowLimit;
    this.constants.languages.forEach(l => {
      if (l.supported) {
        this.languages.push({
          id: l.name,
          itemName: l.display
        });
      }
    });

    this.languages.push({
      id: 'other',
      itemName: 'Other'
    });

    this.languages.unshift({
      id: 'all',
      itemName: 'All Languages'
    });
    this.initSelected();
    this.setDefault();
  }

  initSelected() {
    this.selectedLanguages.forEach(l => {
      if (l == 'all') {
        this.selectedLanguagesInternal.push({ id: 'all', itemName: 'All Languages' });
      }
      else if (l == 'other') {
        this.selectedLanguagesInternal.push({ id: 'other', itemName: 'Other' });
      }
      else {
        let idx = this.constants.languages.findIndex(lang => { return lang.name == l });
        this.selectedLanguagesInternal.push({
          id: this.constants.languages[idx].name,
          itemName: this.constants.languages[idx].display
        });
      }
    });
  }
  6
  languageChange(language) {
    // determine if at least one is selected
    let oneSelected: boolean = false;
    if (this.selectedLanguagesInternal.length > 0) {
      oneSelected = true;
    }

    if (oneSelected && language.id == 'all') {
      // all was just selected
      this.selectedLanguagesInternal = [{ id: 'all', itemName: 'All Languages' }];
    }
    else {
      // a specific language was selected, unselect All if it was selected
      let allIdx = this.selectedLanguagesInternal.findIndex(sl => { return sl.id == 'all' });
      if (allIdx >= 0) {
        this.selectedLanguagesInternal.splice(allIdx, 1);
      }
    }

    if (this.options.required && !oneSelected) {
      this.modalService.show(AlertDialogComponent, Object.assign({}, {
        initialState: {
          message: `At least one language must be selected. We've reset to the default selection`,
          confirmBtn: 'Ok'
        }
      }));

      // select the default options if none are selected but at least one is required
      setTimeout(() => {
        this.setDefault();
        this.emitChange();
      }, 50);
    }
    else {
      this.emitChange();
    }
  }

  emitChange() {
    this.selectedLanguages.length = 0; //clears the array while keeping the reference intact.
    this.selectedLanguagesInternal.forEach(s => {
      this.selectedLanguages.push(s.id);
    });
    this.onChange.emit(this.selectedLanguages);
  }

  private setDefault() {
    if (this.selectedLanguagesInternal.length == 0) {
      this.constants.languages.forEach(l => {
        if (l.supported && this.options.default.include.findIndex(d => { return d == l.name }) >= 0) {
          this.selectedLanguagesInternal.push({
            id: l.name,
            itemName: l.display
          });
        }
      });
    }
  }
}

export interface LanguagePickerOptions {
  badgeShowLimit: number;  // how many items to show as badges in the control
  required: boolean;       // require at least one to be selected
  default: {
    include: string[],
    exclude: string[]
  }      // default selection
}



// WEBPACK FOOTER //
// ./client/app/global/language-picker/language-picker.component.ts